<template>
  <ul v-if="hasNotifications">
    <VNotificationListItem
      v-for="notification in notifications"
      :key="notification.id"
      :notification="notification"
    />
  </ul>
</template>
<script>
import VNotificationListItem from "./VNotificationListItem";
import { createAuthStoreMixin, authStore } from "@/mixins/authStoreMixin";

export default {
  name: "VNotificationList",

  components: {
    VNotificationListItem
  },

  mixins: [createAuthStoreMixin()],

  computed: {
    hasNotifications() {
      return this.notifications.length > 0;
    },
    notifications() {
      return this[authStore.getterTypes.GETTER_NOTIFICATIONS];
    }
  }
};
</script>
